import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import AppRouter from './router/AppRouterOld'
import AuthProvider from './auth/context/AuthProvider'
import { Toaster } from 'sonner'
import ErrorBoundary from './shared/components/errors/ErrorBoundary'
import { startAppVersionWatcher } from './shared/utils/appVersionWatcher'

startAppVersionWatcher();

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            classNames: {
              error: 'text-danger',
              success: 'text-success',
              warning: 'text-warning',
              info: 'text-info',
            },
          }} />
        <ErrorBoundary>
          <AppRouter />
        </ErrorBoundary>
      </AuthProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </StrictMode>,
)
